"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConsultantAnswer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  return <section ref={ref} aria-labelledby="consultant-answer-title" className={`relative w-full bg-background text-foreground py-12 sm:py-16 transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <div className="relative mx-auto max-w-3xl px-6 sm:px-8">
        <h2 id="consultant-answer-title" className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-foreground text-center mb-6">
          What Does a Hospitality Revenue Consultant Actually Do?
        </h2>

        {/* Direct-answer callout block with gold left border and soft secondary tint */}
        <div className="rounded-xl border-l-4 border-secondary bg-secondary/10 p-6 sm:p-7 shadow-sm">
          <p className="font-sans text-base sm:text-lg text-foreground font-medium leading-relaxed">
            I audit OTA extranets daily, stop unauthorized rate discounting, adjust room prices to live booking pickup, and sync your PMS inventory to maximize RevPAR, ADR, and take-home profit.
          </p>
        </div>

        <div className="mt-5 text-center sm:text-right">
          <Link to="/ServicesPage" className="inline-flex items-center text-sm font-semibold text-secondary hover:underline group">
            <span>Learn more about our revenue services</span>
            <ArrowRight className="ml-1.5 size-4 transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>;
}